(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ax-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el, i) {
      if (el.dataset.axDelay) el.style.transitionDelay = el.dataset.axDelay + 'ms';
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  } else {
    initReveal();
  }
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
